<template>
  <nav class="flex h-16 w-full items-center border-y border-[#e0e0e0] bg-white">
    <div class="mx-auto flex w-full max-w-[1140px] items-center justify-between gap-4 px-4">
      <div class="flex h-full items-center gap-2 overflow-x-auto">
        <router-link
          to="/"
          aria-label="Home"
          class="flex h-full shrink-0 items-center justify-center px-3 text-[#5f6673] transition hover:text-[#d9a72e] lg:px-4"
        >
          <svg class="size-[20px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M3 10.5 12 3l9 7.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.5 9.5V21h13V9.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.5 21v-6h5v6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </router-link>
        <div
          v-for="link in navLinks"
          :key="link.label"
          class="flex h-full shrink-0 items-center justify-center px-3 lg:px-5"
          :class="[link.active ? 'border-b-[3px] border-[#d9a72e]' : '', link.href ? 'cursor-pointer' : '']"
          @click="goNavLink(link)"
        >
          <span
            class="whitespace-nowrap text-sm lg:text-base"
            :class="link.active ? 'font-bold text-[#d9a72e]' : 'font-normal text-[#5f6673]'"
          >
            {{ link.label }}
          </span>
        </div>
      </div>
      <button
        type="button"
        class="flex size-11 shrink-0 items-center justify-center rounded-full text-[#202632] transition hover:bg-[#f6f2e8] hover:text-[#d9a72e]"
        aria-label="검색"
        @click="openSearch"
      >
        <svg class="size-[22px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9">
          <circle cx="11" cy="11" r="7" />
          <path d="m16.5 16.5 4 4" stroke-linecap="round" />
        </svg>
      </button>
    </div>

    <teleport to="body">
      <div v-if="searchOpen" class="search-modal-backdrop" @click.self="closeSearch">
        <section class="search-modal" role="dialog" aria-modal="true" aria-labelledby="media-search-title">
          <div class="flex items-start justify-between gap-4">
            <div>
              <h2 id="media-search-title" class="text-xl font-bold text-[#202632]">미디어허브 검색</h2>
              <p class="mt-2 text-sm text-[#6b7280]">노출 콘텐츠의 제목, 설명, 출처에서 검색합니다.</p>
            </div>
            <button type="button" class="close-button" aria-label="닫기" @click="closeSearch">
              <svg class="size-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M6 6l12 12M18 6 6 18" stroke-linecap="round" />
              </svg>
            </button>
          </div>
          <form class="mt-6 flex flex-col gap-3 sm:flex-row" @submit.prevent="submitSearch">
            <input
              ref="searchInput"
              v-model.trim="searchKeyword"
              type="search"
              class="search-input"
              placeholder="검색어를 입력하세요"
              autocomplete="off"
            />
            <button type="submit" class="search-submit">검색</button>
          </form>
        </section>
      </div>
    </teleport>
  </nav>
</template>

<script>
export default {
  name: 'MediaHubHeader',
  data() {
    return {
      navLinks: [
        { label: '회사소개', active: false },
        { label: 'REAL GOLD ASSET', active: false, href: import.meta.env.VITE_MALL_URL || '/' },
        { label: '미디어 허브', active: true },
        { label: '지점안내', active: false },
        { label: 'REAL GOLD TRADE', active: false },
      ],
      searchOpen: false,
      searchKeyword: '',
    }
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    openSearch() {
      this.searchKeyword = this.$route.query.keyword || ''
      this.searchOpen = true
      window.addEventListener('keydown', this.handleKeydown)
      this.$nextTick(() => {
        this.$refs.searchInput?.focus()
      })
    },
    closeSearch() {
      this.searchOpen = false
      window.removeEventListener('keydown', this.handleKeydown)
    },
    handleKeydown(event) {
      if (event.key === 'Escape') this.closeSearch()
    },
    submitSearch() {
      const keyword = this.searchKeyword.trim()
      if (!keyword) {
        this.$refs.searchInput?.focus()
        return
      }
      this.closeSearch()
      this.$router.push({ name: 'media-search', query: { keyword } })
    },
    goNavLink(link) {
      if (!link.href) return
      window.location.href = link.href
    },
  },
}
</script>

<style scoped>
.search-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 96px 20px 20px;
  background: rgba(18, 24, 35, 0.48);
}

.search-modal {
  width: min(560px, 100%);
  border-radius: 18px;
  background: #fff;
  padding: 28px;
  box-shadow: 0 24px 70px rgba(18, 24, 35, 0.26);
}

.close-button {
  display: flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #5f6673;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.close-button:hover {
  background: #f4f5f7;
  color: #202632;
}

.search-input {
  min-width: 0;
  flex: 1;
  height: 50px;
  border: 1px solid #d9dde5;
  border-radius: 12px;
  padding: 0 16px;
  color: #202632;
  font-weight: 700;
  outline: none;
}

.search-input:focus {
  border-color: #d9a72e;
  box-shadow: 0 0 0 3px rgba(217, 167, 46, 0.16);
}

.search-submit {
  height: 50px;
  min-width: 108px;
  border-radius: 12px;
  background: #202632;
  color: #fff;
  font-weight: 800;
}

@media (max-width: 640px) {
  .search-modal-backdrop {
    padding-top: 72px;
  }

  .search-modal {
    padding: 22px;
  }
}
</style>
